import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../../auth/auth.guard';
import { MasterResolver } from '../master/master.resolver';

import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';
import { VehicleEditComponent } from './vehicle-edit/vehicle-edit.component';
import { VehicleNoSelectedComponent } from './vehicle-no-selected/vehicle-no-selected.component';
import { VehiclesComponent } from './vehicles.component';
import { BusinessGuard } from 'src/app/auth/business.guard';

const routes: Routes = [
  {
    path: ':business',
    canActivate: [AuthGuard, BusinessGuard],
    resolve: [MasterResolver],
    data: { breadcrumb: 'business' },
    children: [
      {
        path: 'vehicles',
        component: VehiclesComponent,
        data: { breadcrumb: 'Vehículos' },
        children: [
          { path: '', component: VehicleNoSelectedComponent },

          {
            path: 'new',
            component: VehicleEditComponent,
            data: { breadcrumb: 'Nuevo' },
          },

          {
            path: ':id',
            component: VehicleDetailsComponent,
            data: { breadcrumb: 'Detalle' },
          },

          {
            path: ':id/edit',
            component: VehicleEditComponent,
            data: { breadcrumb: 'Editar' },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VehiclesRoutingModule {}
